import { render } from "./DSLRulesList.vue?vue&type=template&id=984885a4"
import script from "./DSLRulesList.vue?vue&type=script&lang=js"
export * from "./DSLRulesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__